import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import {
  Box,
  Modal,
  Typography,
  Grid,
  TextField,
  Button,
  Autocomplete,
  Tab,
  Tabs,
  MenuItem,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
  CircularProgress,
  Alert,
  Tooltip,
  Stack,
  IconButton,
} from "@mui/material";
import {
  Controller,
  FormProvider,
  useFormContext,
  UseFormReturn,
} from "react-hook-form";
import { MedintDataContext } from "../../Context/MedintContextWrapper";
import {
  generalResearch,
  mediciAge,
  medpgm,
  medpgmp,
  medPrest,
  panodi,
  pgmedt,
} from "../../../../networking";
import MedintFormInterface, {
  formattedAnapreDataObject,
  MedintFormTestataAgenda,
  medintModalTypes,
} from "../../../../services/medintInterfaces";
import { AllertMessage } from "../MedintDetails/MedintDetails";
import MedintDataGrid from "../MedintDataGrid/MedintDataGrid";
import { ReactComponent as DeleteIcon } from "../../../../assets/icons/MedintDeleteIcon.svg";
import { ReactComponent as CopyFromDoctorIcon } from "../../../../assets/icons/MedintCopyFromDoctorIcon.svg";
import { ReactComponent as ModifyIcon } from "../../../../assets/icons/MedintModifyIcon.svg";
import { ReactComponent as AddIcon } from "../../../../assets/icons/MedintAddIcon.svg";
import {
  RHFAutocomplete,
  RHFDateTimePicker,
  RHFTextField,
  RHFTimePicker,
} from "../../../RHFComponents/RHFComponents";
import { StyledDataGrid } from "../../../AppointmentManagement/AppointmentManagementDetail/AppointmentManagementDetail";
import { GridColDef } from "@mui/x-data-grid";
import dayjs from "dayjs";

interface MedintModalProps {
  open: boolean;
  methods: UseFormReturn<MedintFormInterface>;
  onClose: () => void;
  onSubmit: () => void;
  fetchDataMedico: () => Promise<void>;
  title?: string;
  type?: medintModalTypes;
}

const BoxNotifica = (props: { messaggio: string }) => {
  return (
    <Box>
      <Grid>
        <Grid item xs={12} lg={12} xl={12}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "3em",
              fontSize: "1.1rem",
              borderRadius: "8px",
              textAlign: "center",
              backgroundColor: "#FFDF77",
            }}
          >
            <Typography variant="body1">{props.messaggio}</Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

const MedintModal: React.FC<MedintModalProps> = ({
  open,
  onClose,
  methods,
  fetchDataMedico,
  // onSubmit,
  type,
}) => {
  const getTitle = () => {
    switch (type) {
      case "copiaDaMedico":
        return "Copia da Medico";
      case "inserimentoMultiplo":
        return "Inserimento Multiplo";
      case "nuovaAgenda":
        return "Testata Agenda";
      case "nuovoProgramma":
        return "Nuovo Programma";
      case "nonDisponibile":
        return "Nuova Indisponibilità";
      case "duplicaIndisponibilità":
        return "Duplica Indisponibilità";
      case "modificaIndisponibilità":
        return "Modifica Indisponibilità";
      case "inserimento":
        return "Inserimento";
      default:
        return "Titolo del Modale";
    }
  };

  // context per il controllo del form dell'useContext
  const formMethods = useFormContext();
  const context = useContext(MedintDataContext);

  const [disabled, setDisabled] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(false);
  const [dataFound, setDataFound] = useState<boolean>(false);

  // States per la gestione del messaggio che apparirà prima di ogni send del form
  const [showAllert, setShowAllert] = useState<boolean>(false);
  const [severity, setSeverity] = useState<string>("warning");
  const [message, setMessage] = useState<string>("Testo di default");

  const [dataFilteredFound, setDataFilteredFound] = useState<boolean>(true);
  const [checkboxAll, setCheckboxAll] = useState<boolean>(false);

  const copiaDaMedico_Medico = formMethods.watch(
    "medIntNuovaPrestazione.copiaDaMedico.medici",
  );
  const inserimentoMultiplo_Prestazioni = formMethods.watch(
    "medIntNuovaPrestazione.inserimentoMultiplo.prestazioni",
  );
  const inserimentoMultiplo_Specialita = formMethods.watch(
    "medIntNuovaPrestazione.inserimentoMultiplo.specialita",
  );
  const inserimentoMultiplo_Tipologie = formMethods.watch(
    "medIntNuovaPrestazione.inserimentoMultiplo.tipologie",
  );
  const inserimentoMultiplo_Durata = formMethods.watch(
    "medIntNuovaPrestazione.inserimentoMultiplo.durata",
  );
  const inserimentoMultiplo_Nota1 = formMethods.watch(
    "medIntNuovaPrestazione.inserimentoMultiplo.CodiceNota1",
  );
  const inserimentoMultiplo_Nota2 = formMethods.watch(
    "medIntNuovaPrestazione.inserimentoMultiplo.CodiceNota2",
  );
  const nuovaAgenda_tipologia = formMethods.watch(
    "medIntNuovaAgenda.inserimento.tipologia",
  );

  const headersCopiaDaMedico = [
    "Specialità",
    "Prestazione",
    "Tipologia",
    "Durata",
  ];

  const [valoreSpecialita, setValoreSpecialita] = useState<any>(null);
  const [valoriSpecialitaDaEscludere, setValoriSpecialitaDaEscludere] =
    useState<any>(null);
  const [valoreTipologia, setValoreTipologia] = useState<any>(null);
  const [valoriTipologiaDaEscludere, setValoriTipologiaDaEscludere] =
    useState<any>(null);

  const [codiceMedico, setCodiceMedico] = useState<any>(null);
  const [prestazioniFromMedico, setPrestazioniFromMedico] = useState<any>([]);
  const [filteredList, setFilteredList] = useState<any>([]);

  const [prestazioniOptions, setPrestazioniOptions] = useState<any>([]);
  const [specialitaOptions, setSpecialitaOptions] = useState<any>([]);

  const [
    listaInserimentoMultiploPrestazioni,
    setListaInserimentoMultiploPrestazioni,
  ] = useState<any>([]);

  const [loadPGMEDT, setLoadPGMEDT] = useState<boolean>(false);

  const [selectedRows, setSelectedRows] = useState<any>([]);

  const testataAgenda_State = formMethods.watch("testataAgenda.state");
  const testataAgenda_DataIni = formMethods.watch("testataAgenda.dataIni");
  const testataAgenda_DataFin = formMethods.watch("testataAgenda.dataFin");

  // Funzione per gestire l'apertura del dettaglio dell'agenda in insert, update o copy a seconda
  // del click effettuato dall'utente e per settare i valori necessari alla
  // gestione del form in base alla modalità scelta
  const openAgendaDetailWithState = (
    state: NonNullable<MedintFormTestataAgenda["state"]>,
    row?: { chiave?: string; dataIni?: string; dataFin?: string } | null,
  ) => {
    if (state === "insert") {
      methods.setValue("medIntNuovoProgramma.state", "insert");
      methods.setValue(
        "medIntNuovoProgramma.dataIni",
        dayjs(row?.dataIni) ?? dayjs(),
      );
      methods.setValue(
        "medIntNuovoProgramma.dataFin",
        methods.getValues("medIntNuovoProgramma.dataFin") ??
          dayjs("9999-12-31"),
      );
    }

    if (state === "update") {
      methods.setValue("medIntNuovoProgramma.state", "update");
      methods.setValue("medIntNuovoProgramma.dataIni", dayjs(row?.dataIni));
      methods.setValue("medIntNuovoProgramma.dataFin", dayjs(row?.dataFin));
      methods.setValue("medIntNuovoProgramma.chiave", row?.chiave ?? "");
    }

    if (state === "copy") {
      methods.setValue("medIntNuovoProgramma.state", "copy");
      methods.setValue("medIntNuovoProgramma.dataIni", dayjs(row?.dataIni));
      methods.setValue("medIntNuovoProgramma.dataFin", dayjs(row?.dataFin));
      methods.setValue("medIntNuovoProgramma.chiave", row?.chiave ?? "");
    }

    context?.setFullViewAgendaForm(true);
  };

  const handleClickInserisciAgenda = () =>
    openAgendaDetailWithState("insert", null);

  const handleClickUpdateAgenda = (e: React.MouseEvent, row: any) => {
    e.stopPropagation();
    openAgendaDetailWithState("update", row);
  };

  const handleClickCopyAgenda = (e: React.MouseEvent, row: any) => {
    e.stopPropagation();
    openAgendaDetailWithState("copy", row);
  };

  // Controllo a monte della modale aperta per gestirne le logiche
  useEffect(() => {
    if (!open) {
      return;
    }

    // reset dell'istanza solo dei valori sul form della nuovaAgenda
    if (
      !methods.getValues("testataAgenda.idMedPgm") &&
      !methods.getValues("testataAgenda.idMedT") &&
      type === "nuovaAgenda"
    ) {
      methods.setValue("testataAgenda.state", "insert");
      methods.setValue("testataAgenda.dataIni", dayjs());
      methods.setValue("testataAgenda.dataFin", dayjs());
      methods.setValue("testataAgenda.codProgramma", null);
      methods.setValue("testataAgenda.tabellaOrari", []);
    }
    return () => {
      methods.setValue("testataAgenda.codProgramma", null);
      methods.setValue("testataAgenda.dataIni", dayjs());
      methods.setValue("testataAgenda.dataFin", dayjs());
      methods.setValue("testataAgenda.tabellaOrari", []);
    };
  }, [open]);

  const filterAgendeProgrammiByParams = async (results: any) => {
    const checkIfDefault =
      dayjs(testataAgenda_DataFin).format("YYYY-MM-DD") === "9999-12-31"
        ? null
        : testataAgenda_DataFin;

    if (checkIfDefault !== null) {
      let filteredResults = results?.filter(
        (e: any) =>
          dayjs(e?.dataFin).isAfter(methods.watch("testataAgenda.dataFin")) ||
          dayjs(e?.dataFin).isSame(methods.watch("testataAgenda.dataFin")),
      );

      // per sicurezza valorizzo anche il ref di useForm
      methods.setValue("testataAgenda.tabellaOrari", filteredResults);
    } else {
      methods.setValue("testataAgenda.tabellaOrari", results);
    }
    setLoadPGMEDT(false);
  };

  useEffect(() => {
    const tempDataIni = methods.getValues("testataAgenda.dataIni");
    const tempProgramma = methods.getValues("testataAgenda.codProgramma");

    if (tempDataIni !== null && tempProgramma !== null && open) {
      setLoadPGMEDT(true);
      try {
        const promise = async () =>
          await generalResearch({
            tabella: "PGMEDT",
            codice: "",
            filtro: "",
            applicazione: "",
            attivi: "0",
            dataRif: dayjs(tempDataIni).format("YYYY-MM-DD"),
            filtriFissi: [
              {
                colFixFlt: "PGMEDT_CODICE",
                fixFlt: tempProgramma?.codProg ?? "",
              },
            ],
          });
        promise()
          .then(async (response) => {
            const formattedArray = Array.isArray(response.data.dati)
              ? response.data.dati
              : [response.data.dati];

            const mappedAgendaProgramma = formattedArray?.map(
              (e: any, index: number) => {
                return {
                  id: index,
                  chiave: e.pkey ?? "",
                  codProg: e["cod.programma"] ?? "",
                  agenda: e.descrizione ?? "",
                  dataIni: e["data inizio validit"] ?? "",
                  dataFin: e["data fine validit"] ?? "",
                };
              },
            );
            return mappedAgendaProgramma;
          })
          .then(
            async (mappedResults) =>
              await filterAgendeProgrammiByParams(mappedResults),
          );
      } catch (error) {
        console.warn(
          "Errore durante la request dei dati avvenuta al recupero della selezione del codice",
        );
      }
    }
  }, [
    methods.getValues("testataAgenda.dataIni"),
    methods.getValues("testataAgenda.dataFin"),
    methods.getValues("testataAgenda.codProgramma"),
  ]);

  // controllo se richiamare o meno al cambio della data di Inizio field value, perché si devono aggiornare
  useEffect(() => {
    if (!dayjs(methods.watch("testataAgenda.dataIni")).isSame(dayjs())) {
      context?.requestCodiciProgramma(
        dayjs(methods.watch("testataAgenda.dataIni")).format("YYYY-MM-DD"),
      );
    }
  }, [methods.watch("testataAgenda.dataIni")]);

  // gestisco l'assegnazione al click del singolo checkbox per riga
  const handleRowClick = (rowData: any) => {
    if (selectedRows?.includes(rowData)) {
      const listFiltered = selectedRows.filter(
        (e: any) =>
          e.Codice !== rowData.Codice || e.Tipologia !== rowData.Tipologia,
      );
      setSelectedRows(listFiltered);
    } else {
      setSelectedRows([...selectedRows, rowData]);
    }
  };

  const handleCheckboxAllClick = (rowListData: any) => {
    !checkboxAll ? setSelectedRows(rowListData) : setSelectedRows([]);
  };

  // recupero dei dati del medico in input dall'autocomplete della CopiaDaMedico
  const tempDocData = async () => {
    setLoading(true);
    try {
      const response = await mediciAge({
        idMedico: codiceMedico,
        crud: "r",
      });

      const prestazioniDaEscludere = context?.prestazioniErogabili.map((p) => ({
        CODICEANAPRE: p.Codice,
        DESCRTIPOAGENDA: p.Agenda,
      }));

      console.log(response?.data?.dati?.prestazioni);

      const mappedData = response.data?.dati?.prestazioni
        ?.filter(
          (row: any) =>
            !prestazioniDaEscludere?.some(
              (e) =>
                e.CODICEANAPRE === row.CODICEANAPRE &&
                e.DESCRTIPOAGENDA === row.DESCRTIPOAGENDA,
            ),
        )
        ?.map((row: any) => ({
          MedPrest: row.IDMEDPREST,
          Specialità: row.CODICESPECIALITA,
          Prestazione: row.DSCANAPRE,
          Agenda: row.DESCRTIPOAGENDA,
          Tipologia: row.DESCRTIPOAGENDA,
          Durata: row.DURATAPREST,
          //Lo lascio comunque per la send
          Codice: row.CODICEANAPRE,
        }));

      // lista temporanea di specialità come parametro da includere durante la generazione delle opzioni selezionabili
      const tempCodiciSpecialitàDaEscludere = mappedData
        .reduce((acc: any[], curr: any) => {
          const trovato = acc.some(
            (element) => element.Specialità === curr.Specialità,
          );
          if (!trovato) {
            acc.push(curr);
          }
          return acc;
        }, [])
        .map((e: any) => e.Specialità);

      // lista temporanea di tipologie come parametro da includere durante la generazione delle opzioni selezionabili
      const tempTipologieDaEscludere = mappedData
        .reduce((acc: any[], curr: any) => {
          const trovato = acc.some(
            (element) => element.Tipologia === curr.Tipologia,
          );
          if (!trovato) {
            acc.push(curr);
          }
          return acc;
        }, [])
        .map((e: any) => e.Tipologia);

      console.log("PRESTAZIONI DA ESCLUDERE", prestazioniDaEscludere);

      setValoriSpecialitaDaEscludere(tempCodiciSpecialitàDaEscludere);
      setValoriTipologiaDaEscludere(tempTipologieDaEscludere);
      setPrestazioniFromMedico(mappedData);
      setDataFound(response.data.dati.prestazioni.length > 0 ? true : false);
    } catch (error) {
      console.error(
        "Errore nella fetch del medico durante selezione dalla copia:",
        error,
        error,
      );
    } finally {
      setLoading(false);
    }
  };

  // funzione per l'invio dei dati di una prestazione da assegnare ad un medico
  const sendDataPrestazioni = async (data: any) => {
    // console.log("Sending", data);
    // console.log("IDMEDINT", context?.doctorAgenda.medico);

    try {
      const response = await medPrest({
        idMedint: context?.doctorAgenda.medico[0].IDMEDICO,
        crud: "C",
        prestazioni: [
          {
            idSpecia: "",
            codiceSpecia: data?.Specialità ?? data?.specialita ?? "",
            idAnapre: data?.idAnapre ?? "",
            codiceAnapre: data?.Codice ?? data?.codice,
            idTpgpre: "",
            codiceTpgpre: inserimentoMultiplo_Tipologie?.CODICE ?? " ",
            durataMin:
              inserimentoMultiplo_Durata?.length < 1 ||
              !inserimentoMultiplo_Durata
                ? (data?.durata ?? data?.Durata)
                : inserimentoMultiplo_Durata,
            attesaMin: "",
            nMaxPrest: "",
            minutiInizio: "",
            dataFineValidita: "9999-12-31",
            flagAccettazione: "",
            nota1: inserimentoMultiplo_Nota1?.codice ?? "",
            nota2: inserimentoMultiplo_Nota2?.codice ?? "",
            idPgmedt: "",
            programma: "",
            etaMin: "",
            etaMax: "",
            genere: "",
            flagAgendaParticolare: "",
            codiceParticolarita: "",
            flagRaggruppabile: "",
            codiceRaggruppamento: "",
            ricercaRagggp: "",
            flagEscludiGP: "",
            tempoPreparazione: "",
            codPgmedt: "",
            codMedintSost: "",
            codAnapreSost: "",
          },
        ],
      });

      setMessage(response.data[0].messaggio);

      console.log("Risposta della send", response);

      if (response.data[0].esito === "OK") {
        setSeverity("success");
        setTimeout(() => {
          onClose();
          formMethods.reset();
          setCodiceMedico(null);
          setPrestazioniFromMedico(null);
        }, 5500);
      } else if (response.data[0].esito === "KO") {
        setSeverity("warning");
      } else {
        setSeverity("error");
        setMessage(
          "Registrazione database fallita, contattare l'amministratore",
        );
      }
    } catch (error) {
      console.warn("Si è presentato un errore durante l'inserimento", error);
    }
  };

  // funzione per l'invio dei dati di una prestazione da assegnare ad un medico
  const sendDataAgenda = async (data: any) => {
    const operationMap: Record<string, string> = {
      insert: "c",
      update: "u",
      copy: "c",
    };

    const crudOperation =
      operationMap[methods?.getValues("testataAgenda.state") ?? ""] ?? "";

    const idMedPgm = methods?.getValues("testataAgenda.idMedPgm");
    const idMedT = methods?.getValues("testataAgenda.idMedT");
    const dataIni = methods?.getValues("testataAgenda.dataIni");
    const dataFin = methods?.getValues("testataAgenda.dataFin");

    const updateRequest =
      typeof idMedPgm === "string" &&
      idMedPgm.trim() !== "" &&
      typeof idMedT === "string" &&
      idMedT.trim() !== "";

    try {
      const response = await medpgm({
        crud: crudOperation,
        idMedint: context?.doctorAgenda.medico[0].IDMEDICO ?? "",
        idPgmedt: updateRequest ? idMedT : data[0]?.chiave, //id record del pgmedt di inizio validità
        idMedpgm: updateRequest ? idMedPgm : "",
        dataIniValidita: updateRequest
          ? dayjs(dataIni).format("YYYY-MM-DD")
          : data[0].dataIni,
        dataFineValidita: updateRequest
          ? dayjs(dataFin).format("YYYY-MM-DD")
          : data[0].dataFin,
      });

      setMessage(response?.data?.messaggio ?? "");

      console.log("Risposta della send", response);

      if (response.data.esito === "OK") {
        setSeverity("success");
      } else if (response.data.esito === "KO") {
        setSeverity("warning");
      } else {
        setSeverity("error");
        setMessage(
          "Registrazione database fallita, contattare l'amministratore",
        );
      }
    } catch (error) {
      console.warn(
        "Si è presentato un errore durante la creazione del programma",
        error,
      );
    } finally {
      setShowAllert(true);
      setTimeout(() => {
        onClose();
        formMethods.reset();
        setShowAllert(false);
      }, 5000);
    }
  };

  // funzione che richiama sendDataPrestazione per ogni prestazione selezionata dall'utente e che eseguira il set dello risposta
  const cicloChiamateMEDPREST = async () => {
    try {
      for (const element of selectedRows) {
        await sendDataPrestazioni(element);
      }
    } catch (error) {
      console.warn(
        "Errore durante la send dei dati avvenuta in cicloChiamateMEDPREST",
      );
    } finally {
      setShowAllert(true);
      setTimeout(() => {
        setShowAllert(false);
      }, 5000);
    }
    return;
  };

  const handleIndisponibilita = async () => {
    try {
      const values = formMethods.getValues("medIntIndisponibilita");
      const idMedico = context?.doctorAgenda?.medico?.[0]?.IDMEDICO;

      const response = await panodi({
        crud: type === "modificaIndisponibilità" ? "U" : "C",
        idMedint: idMedico,
        idPanodi: type === "modificaIndisponibilità" ? values.idPanodi : "",
        dataInizio: values.dataInizio,
        dataFine: values.dataFine,
        oraInizio: values.oraInizio,
        oraFine: values.oraFine,
        descrizione: values.note,
        giorniSelezionati: [true, true, true, true, true, true, false],
      });

      const esito = response.data?.[0]?.esito;
      const messaggio = response.data?.[0]?.messaggio;

      if (esito === "OK") {
        setSeverity("success");
        setMessage(messaggio || "Indisponibilità salvata con successo");
      } else {
        console.warn("⚠️ Errore salvataggio:", messaggio);
        setSeverity("warning");
        setMessage(messaggio || "Errore nella registrazione");
      }
    } catch (error) {
      setSeverity("error");
      setMessage("Errore durante il salvataggio. Contatta l'amministratore.");
      setShowAllert(true);
      console.error(error);
    } finally {
      setShowAllert(true);
      setTimeout(() => {
        setShowAllert(false);
      }, 5000);
    }
  };

  useEffect(() => {
    if (codiceMedico) {
      tempDocData();
    }
    if (codiceMedico) {
      setDisabled(false);
    } else {
      setValoreSpecialita(null);
      setValoreTipologia(null);
      setDataFilteredFound(true);
      setPrestazioniFromMedico(null);
      setDisabled(true);
      setDataFound(false);
      setSelectedRows([]);
    }

    // console.log("LISTA SPECIALITA'", context?.specialitiesSPECIALITA);
  }, [copiaDaMedico_Medico]);

  useEffect(() => {
    if (!valoreSpecialita && !valoreTipologia) {
      setDataFilteredFound(true);
      setFilteredList(prestazioniFromMedico);
    }

    if (valoreSpecialita || valoreTipologia) {
      const tempList = prestazioniFromMedico?.filter(
        (row: any) =>
          (!valoreSpecialita ||
            valoreSpecialita.SPECIALITA === row.Specialità) &&
          (!valoreTipologia || valoreTipologia.DESCRIZIONE === row.Tipologia),
      );

      if (tempList?.length === 0) {
        setDataFilteredFound(false);
      } else {
        setFilteredList(tempList);
        setDataFilteredFound(true);
      }
    }

    setSelectedRows([]);
    setCheckboxAll(false);
  }, [valoreSpecialita, valoreTipologia, prestazioniFromMedico]);

  // useEffect che filtra le prestazioni in base alla selezione effettuata sui campi appositi in finestra di inserimento
  useEffect(() => {
    const filteredOptionsPrestazioni = context?.performancePRESTAZIONI?.filter(
      (element: any) =>
        element?.SPECIALITA === inserimentoMultiplo_Specialita?.SPECIALITA,
    );

    const prestazioniOptions = filteredOptionsPrestazioni?.length
      ? filteredOptionsPrestazioni
      : context?.performancePRESTAZIONI || [];

    setPrestazioniOptions(prestazioniOptions);

    const filteredOptionsSpecialita = context?.specialitiesSPECIALITA?.filter(
      (element: any) =>
        element?.SPECIALITA === inserimentoMultiplo_Prestazioni?.SPECIALITA,
    );

    const specialitaOptions = filteredOptionsSpecialita?.length
      ? filteredOptionsSpecialita
      : context?.specialitiesSPECIALITA || [];

    console.log({ inserimentoMultiplo_Tipologie });

    setSpecialitaOptions(specialitaOptions);
    console.log({ specialitaOptions });
  }, [
    inserimentoMultiplo_Prestazioni,
    inserimentoMultiplo_Specialita,
    inserimentoMultiplo_Tipologie,
  ]);

  useEffect(() => {
    const tempListaInserimentoMultiploPrestazioni = context?.prestazioniANAPRE
      .filter((e: formattedAnapreDataObject) => {
        return (
          e?.specialita === inserimentoMultiplo_Specialita?.SPECIALITA &&
          (!inserimentoMultiplo_Prestazioni ||
            inserimentoMultiplo_Prestazioni?.DESCRIZIONE?.includes(
              e?.prestazione,
            ))
        );
      })
      ?.map((e: any) => ({
        ...e,
        durata:
          inserimentoMultiplo_Durata?.length < 1 || !inserimentoMultiplo_Durata
            ? 0
            : inserimentoMultiplo_Durata,
      }));

    setListaInserimentoMultiploPrestazioni(
      tempListaInserimentoMultiploPrestazioni,
    );
  }, [
    inserimentoMultiplo_Specialita,
    inserimentoMultiplo_Prestazioni,
    inserimentoMultiplo_Durata,
  ]);

  const onSubmit = async () => {
    switch (type) {
      case "copiaDaMedico":
        console.log("COPIA MEDICO invio questo data:", selectedRows);
        cicloChiamateMEDPREST();
        return;
      case "inserimentoMultiplo":
        console.log("INSERIMENTO MULTIPLO", selectedRows);
        cicloChiamateMEDPREST();
        return;
      case "nuovaAgenda":
        console.log("NUOVA AGENDA");
        sendDataAgenda(methods.getValues("testataAgenda.tabellaOrari"));
        return;
      case "nuovoProgramma":
        console.log("NUOVO PROGRAMMA");
        return;
      case "nonDisponibile":
        handleIndisponibilita();
        return;
      case "duplicaIndisponibilità":
        console.log("DUPLICA DISPONIBILITA");
        return;
      case "modificaIndisponibilità":
        console.log(formMethods.getValues("medIntIndisponibilita"));
        return;
      case "ricoveri":
        console.log(formMethods.getValues("ricoveri"));
        return;
      default:
        break;
    }
  };

  function openModal(arg0: string): void {
    throw new Error("Function not implemented.");
  }

  const agendaProgramCols: GridColDef[] = [
    { field: "id" },
    {
      field: "agenda",
      headerName: "Agende",
      flex: 1,
    },
    {
      field: "dataIni",
      headerName: "Inizio",
      flex: 1,
      renderCell: (value: any) => {
        return `${dayjs(value.row.dataIni).format(`DD/MM/YYYY`)}`;
      },
    },
    {
      field: "dataFin",
      headerName: "Fine",
      flex: 1,
      renderCell: (value: any) => {
        return `${dayjs(value.row.dataFin).format(`DD/MM/YYYY`)}`;
      },
    },
    {
      field: "azioni",
      headerAlign: "center",
      align: "center",
      headerName: "Azioni",
      flex: 0.5,
      renderCell: (params: any) => (
        <>
          <IconButton
            size="small"
            onClick={(e) => handleClickUpdateAgenda(e, params.row)}
            sx={{
              color: "#024E88",
            }}
          >
            <ModifyIcon />
          </IconButton>

          <IconButton
            size="small"
            onClick={(e) => handleClickCopyAgenda(e, params.row)}
            sx={{
              color: "#024E88",
            }}
          >
            {" "}
            <CopyFromDoctorIcon />
          </IconButton>

          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
            }}
            sx={{
              color: "#D32F2F",
            }}
          >
            <DeleteIcon />
          </IconButton>
        </>
      ),
    },
  ];

  return (
    <>
      <Modal
        open={open}
        onClose={(event, reason) => {
          //Se reason (motivo) è "backdropClick (click fuori dal modale)" non chiudere il modale
          if (reason === "backdropClick") {
            return;
          }
          onClose();
        }}
        //Se viene premuto esc non si chiude il modale
        disableEscapeKeyDown
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            maxWidth: 900,
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: 2,
            p: 4,
          }}
        >
          <AllertMessage
            showAllert={showAllert}
            setShowAllert={setShowAllert}
            severity={severity}
            message={message}
          />
          <Typography variant="h6" sx={{ mb: 3, fontWeight: "bold" }}>
            {getTitle()}
          </Typography>

          {type === "copiaDaMedico" && (
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <RHFAutocomplete
                  name="medIntNuovaPrestazione.copiaDaMedico.medici"
                  fullWidth
                  label="Medico"
                  placeholder="Medico"
                  control={formMethods.control}
                  options={
                    context?.doctorsData?.filter(
                      (doctor) =>
                        doctor["codice medico"] !==
                        context.doctorAgenda.medico[0].CODICEMEDICO,
                    ) || []
                  }
                  autoComplete
                  autoHighlight
                  isOptionEqualToValue={(o: any, v: any) => o?.pkey === v?.pkey}
                  onValueChange={(medico: any) => {
                    const nextId = medico?.pkey ?? null;
                    setCodiceMedico(nextId);
                  }}
                  getOptionLabel={(option) => {
                    if (!option) return "";
                    return `${option["codice medico"]?.concat(" - ") ?? ""}${
                      option.cognome ?? ""
                    } ${option.nome ?? ""}`.trim();
                  }}
                  renderOption={(props, option) => (
                    <MenuItem {...props} key={option.pkey}>
                      {`${option["codice medico"]?.concat(" - ")}${
                        option.cognome
                      } ${option.nome}`}
                    </MenuItem>
                  )}
                />
              </Grid>
              <Grid item xs={12} md={4} />
              <Grid item xs={12} md={4} />
              <Grid item xs={12} md={4}>
                <Autocomplete
                  autoComplete
                  autoHighlight
                  disabled={disabled}
                  size="small"
                  options={
                    context?.specialitiesSPECIALITA.filter((specialità: any) =>
                      valoriSpecialitaDaEscludere?.includes(
                        specialità.SPECIALITA,
                      ),
                    ) || []
                  }
                  getOptionLabel={(option: any) => option.DESCRIZIONE || ""}
                  onChange={(event: any, newValue: any) => {
                    setValoreSpecialita(newValue);
                  }}
                  value={valoreSpecialita}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Specialità"
                      placeholder="Specialità"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Autocomplete
                  autoComplete
                  autoHighlight
                  disabled={disabled}
                  size="small"
                  options={
                    context?.typologiesTIPOLOGIE.filter((tipologia: any) =>
                      valoriTipologiaDaEscludere?.includes(
                        tipologia.DESCRIZIONE,
                      ),
                    ) || []
                  }
                  getOptionLabel={(option: any) => option.DESCRIZIONE || ""}
                  onChange={(event: any, newValue: any) => {
                    setValoreTipologia(newValue);
                  }}
                  value={valoreTipologia}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Tipologia"
                      placeholder="Tipologia"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                {!loading && dataFound && dataFilteredFound && (
                  <TableContainer
                    sx={{
                      boxSizing: "border-box",
                      width: "auto",
                      display: "flex",
                      maxHeight: "350px",
                      borderRadius: "8px",
                      border: "1px solid rgba(204, 204, 204, 0.80)",
                    }}
                  >
                    <Table
                      size="small"
                      stickyHeader
                      sx={{ minWidth: 400, boxSizing: "border-box" }}
                    >
                      <TableHead sx={{ boxSizing: "border-box" }}>
                        <TableRow
                          sx={{
                            backgroundColor: "#002F6C",
                            height: "40px",
                            boxSizing: "border-box",
                          }}
                        >
                          <TableCell padding="checkbox">
                            <Checkbox
                              color="primary"
                              sx={{
                                color: "white",
                                "&.Mui-checked": {
                                  color: "white",
                                },
                              }}
                              checked={checkboxAll}
                              onClick={() => {
                                setCheckboxAll(!checkboxAll);
                                handleCheckboxAllClick(filteredList);
                              }}
                            />
                          </TableCell>
                          {headersCopiaDaMedico.map((header, index) => (
                            <TableCell
                              key={index}
                              sx={{ color: "white", fontWeight: "bold" }}
                            >
                              {header}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>

                      {/* <EnhancedTableHead headCells={headersCopiaDaMedico} /> */}

                      <TableBody sx={{ boxSizing: "border-box" }}>
                        {filteredList?.map((row: any, rowIndex: any) => {
                          return (
                            <TableRow
                              key={rowIndex}
                              // hover={rowIndex !== }
                            >
                              <TableCell padding="checkbox">
                                <Checkbox
                                  color="primary"
                                  checked={selectedRows?.includes(row)}
                                  onClick={() => {
                                    handleRowClick(row);
                                  }}
                                  inputProps={{
                                    "aria-labelledby": rowIndex.toString(),
                                  }}
                                />
                              </TableCell>
                              {headersCopiaDaMedico.map((header, colIndex) => {
                                return (
                                  <TableCell key={colIndex}>
                                    <Typography
                                      fontSize={
                                        row[header] !== undefined
                                          ? row[header].length > 24
                                            ? 11
                                            : ""
                                          : ""
                                      }
                                    >
                                      {row[header] !== undefined
                                        ? row[header]
                                        : "—"}
                                      {header === "Durata" ? " min" : ""}
                                    </Typography>
                                  </TableCell>
                                );
                              })}
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
                {!loading && !dataFilteredFound && codiceMedico && (
                  <BoxNotifica
                    messaggio={"Il filtro non ha prodotto risultati"}
                  />
                )}
                {!loading && !dataFound && codiceMedico && (
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Alert
                      severity="warning"
                      sx={{
                        border: "1px solid #e65100",
                        alignContent: "center",
                        alignItems: "center",
                        "& .MuiAlert-icon": {
                          marginLeft: 2,
                          fontSize: 40,
                        },
                      }}
                    >
                      <Box>
                        <Typography
                          component="div"
                          marginTop={"20px"}
                          marginLeft={"20px"}
                          marginRight={"10px"}
                          marginBottom={"20px"}
                          fontSize={"20px"}
                          fontWeight={"bold"}
                        >
                          Non sono state trovate prestazioni per questo medico.
                        </Typography>
                      </Box>
                    </Alert>
                  </Box>
                )}
              </Grid>
            </Grid>
          )}

          {type === "inserimentoMultiplo" && (
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <RHFAutocomplete
                  name="medIntNuovaPrestazione.inserimentoMultiplo.specialita"
                  control={formMethods.control}
                  fullWidth
                  label="Selezionare una specialità"
                  options={specialitaOptions || []}
                  autoComplete
                  autoHighlight
                  getOptionLabel={(o: any) => o?.DESCRIZIONE || ""}
                  isOptionEqualToValue={(o: any, v: any) =>
                    o?.DESCRIZIONE === v?.DESCRIZIONE
                  }
                />
              </Grid>

              <Grid item xs={0} md={6} />

              <Grid item xs={12} md={6}>
                <RHFAutocomplete
                  name="medIntNuovaPrestazione.inserimentoMultiplo.prestazioni"
                  control={formMethods.control}
                  fullWidth
                  label="Selezionare una prestazione"
                  options={prestazioniOptions || []}
                  autoComplete
                  autoHighlight
                  getOptionLabel={(o: any) => o?.DESPRESTAZIONE || ""}
                  isOptionEqualToValue={(o: any, v: any) =>
                    o?.DESCRIZIONE === v?.DESCRIZIONE
                  }
                  renderOption={(props, option, { index }) => (
                    <MenuItem {...props} key={index}>
                      {option?.DESPRESTAZIONE}
                    </MenuItem>
                  )}
                />
              </Grid>

              {inserimentoMultiplo_Specialita && (
                <>
                  <Grid item xs={12} md={12}>
                    <MedintDataGrid
                      data={listaInserimentoMultiploPrestazioni}
                      selectedRows={selectedRows}
                      setSelectedRows={setSelectedRows}
                    />
                  </Grid>

                  <Grid item xs={6} md={4}>
                    <RHFAutocomplete
                      name="medIntNuovaPrestazione.inserimentoMultiplo.tipologie"
                      control={formMethods.control}
                      fullWidth
                      label="Selezionare una tipologia"
                      options={context?.typologiesTIPOLOGIE || []}
                      autoComplete
                      autoHighlight
                      getOptionLabel={(o: any) => o?.DESCRIZIONE || ""}
                      isOptionEqualToValue={(o: any, v: any) =>
                        o?.DESCRIZIONE === v?.DESCRIZIONE
                      }
                    />
                  </Grid>

                  <Grid item xs={4} md={4}>
                    <Controller
                      name="medIntNuovaPrestazione.inserimentoMultiplo.durata"
                      control={formMethods.control}
                      rules={{
                        required: true,
                        min: 0,
                        max: 60,
                        validate: (value) => !isNaN(value) && value <= 60,
                      }}
                      render={({ field, fieldState }) => (
                        <TextField
                          {...field}
                          label="Durata"
                          placeholder="Durata"
                          variant="outlined"
                          type="number"
                          fullWidth
                          size="small"
                          value={field.value ?? ""}
                          inputProps={{
                            min: 0,
                            max: 60,
                            step: 1,
                          }}
                          error={!!fieldState.error}
                          helperText={
                            fieldState.error
                              ? "Inserisci un numero da 0 a 60"
                              : ""
                          }
                          onChange={(e) => {
                            const rawValue = e.target.value;
                            const parsedValue = parseInt(rawValue);

                            if (!isNaN(parsedValue)) {
                              // Limita il valore a 60
                              const clampedValue = Math.min(
                                Math.max(parsedValue, 0),
                                60,
                              );
                              field.onChange(clampedValue);
                            } else {
                              // Consenti stringa vuota per cancellazione
                              field.onChange("");
                            }
                          }}
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={4} md={4} />
                  {/* CODICE NOTA 1 */}
                  <Grid item xs={6} md={4}>
                    <Controller
                      name="medIntNuovaPrestazione.inserimentoMultiplo.CodiceNota1"
                      control={formMethods.control}
                      render={({ field }) => (
                        <Autocomplete
                          autoComplete
                          autoHighlight
                          size="small"
                          options={context?.dettagliNotePANOTET || []}
                          getOptionLabel={(option) =>
                            `[${option.codice}] ${option.descrizione}` || ""
                          }
                          onChange={(_, data) => {
                            field.onChange(data);
                            formMethods.setValue(
                              "medIntNuovaPrestazione.inserimentoMultiplo.DescrizioneNota1",
                              data?.descrizione,
                            );
                          }}
                          isOptionEqualToValue={(option, value) =>
                            option.codice === value.codice
                          }
                          value={field.value || null}
                          renderInput={(params) => (
                            <Tooltip
                              title={formMethods.getValues(
                                "medIntNuovaPrestazione.inserimentoMultiplo.DescrizioneNota1",
                              )}
                            >
                              <TextField
                                {...params}
                                placeholder="Selezionare"
                                label="Nota 2"
                                variant="outlined"
                                fullWidth
                                size="small"
                              />
                            </Tooltip>
                          )}
                          clearOnEscape
                        />
                      )}
                    />
                  </Grid>
                  {/* CODICE NOTA 2 */}
                  <Grid item xs={6} md={4}>
                    <Controller
                      name="medIntNuovaPrestazione.inserimentoMultiplo.CodiceNota2"
                      control={formMethods.control}
                      render={({ field }) => (
                        <Autocomplete
                          autoComplete
                          autoHighlight
                          size="small"
                          options={context?.dettagliNotePANOTET || []}
                          getOptionLabel={(option) =>
                            `[${option.codice}] ${option.descrizione}` || ""
                          }
                          onChange={(_, data) => {
                            field.onChange(data);
                            formMethods.setValue(
                              "medIntNuovaPrestazione.inserimentoMultiplo.DescrizioneNota2",
                              data?.descrizione,
                            );
                          }}
                          isOptionEqualToValue={(option, value) =>
                            option.codice === value.codice
                          }
                          value={field.value || null}
                          renderInput={(params) => (
                            <Tooltip
                              title={formMethods.getValues(
                                "medIntNuovaPrestazione.inserimentoMultiplo.DescrizioneNota2",
                              )}
                            >
                              <TextField
                                {...params}
                                placeholder="Selezionare"
                                label="Nota 2"
                                variant="outlined"
                                fullWidth
                                size="small"
                              />
                            </Tooltip>
                          )}
                          clearOnEscape
                        />
                      )}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          )}

          {type === "nuovaAgenda" && (
            <>
              <Grid container display={"flex"} spacing={2}>
                <Grid item xs={6}>
                  <RHFDateTimePicker
                    dateOnly
                    name="testataAgenda.dataIni"
                    label="Inizio validità"
                    serialize="dayjs"
                    fullWidth
                    disabled={testataAgenda_State === "copy"}
                    control={formMethods.control}
                    rules={{ required: "Campo obbligatorio" }}
                    valueFormat="YYYY-MM-DD"
                    displayFormat="DD/MM/YYYY"
                  />
                </Grid>
                <Grid item xs={6}>
                  <RHFDateTimePicker
                    dateOnly
                    name="testataAgenda.dataFin"
                    label="Fine validità"
                    serialize="dayjs"
                    fullWidth
                    disabled={testataAgenda_State === "copy"}
                    control={formMethods.control}
                    rules={{ required: "Campo obbligatorio" }}
                    valueFormat="YYYY-MM-DD"
                    displayFormat={"DD/MM/YYYY"}
                    minValue={methods.watch("testataAgenda.dataIni")}
                  />
                </Grid>
                <Grid item xs={6}>
                  <RHFAutocomplete
                    name="testataAgenda.codProgramma"
                    control={formMethods.control}
                    fullWidth
                    label="Codice Programma"
                    options={context?.codiciProgrammaPGMEDT || []}
                    disabled={
                      methods.getValues("testataAgenda.dataIni") === null ||
                      testataAgenda_State === "copy"
                    }
                    autoComplete
                    autoHighlight
                    getOptionLabel={(o: any) =>
                      `[${o.codProg}] ${o?.descrizione}` || ""
                    }
                    isOptionEqualToValue={(o: any, v: any) =>
                      o?.descrizione === v?.descrizione
                    }
                  />
                </Grid>
                <Grid item xs={6}></Grid>
                <Grid
                  item
                  xs={10}
                  display={"flex"}
                  justifyContent={"flex-start"}
                  alignContent={"center"}
                  alignItems={"center"}
                >
                  <Typography
                    sx={{
                      color: "rgba(0, 0, 0, 0.60)",
                      fontWeight: "bold",
                    }}
                  >
                    Orari in corso sul Programma/Agenda
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={2}
                  display={"flex"}
                  justifyContent={"flex-end"}
                  alignItems={"center"}
                  justifyItems={"center"}
                >
                  <Button
                    variant="outlined"
                    sx={{ maxHeight: "35px", maxWidth: "110px" }}
                    onClick={handleClickInserisciAgenda}
                  >
                    <Stack gap={1} direction="row">
                      <AddIcon className="medintIcons" />
                      <Typography sx={{ fontWeight: "bold" }}>
                        Inserisci
                      </Typography>
                    </Stack>
                  </Button>
                </Grid>
                <Grid item xs={12}>
                  <StyledDataGrid
                    rows={methods.watch("testataAgenda.tabellaOrari") ?? []}
                    columns={agendaProgramCols}
                    getRowId={(r) => r.id}
                    sortingOrder={["desc", "asc", null]}
                    columnVisibilityModel={{
                      id: false,
                    }}
                    loading={loadPGMEDT}
                    pageSize={10}
                    onRowClick={(e: any) => {
                      console.log(e.row);
                    }}
                    pagination // abilita il paging
                    sx={{
                      height: 200,
                      '& .MuiDataGrid-columnHeaders [data-field="__orderBySelected__"] .MuiDataGrid-sortIcon':
                        {
                          display: "none",
                        },
                      "& .MuiDataGrid-row:hover": {
                        backgroundColor: "#f5f5f5",
                        cursor: "pointer",
                      },

                      "& .MuiDataGrid-row.Mui-selected:hover": {
                        backgroundColor: "#bbdefb !important",
                      },
                      "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within":
                        {
                          outline: "none",
                        },
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Button variant="outlinedError" onClick={onClose}>
                    Uscita
                  </Button>
                </Grid>
                <Grid item xs={10} display={"flex"} justifyContent={"flex-end"}>
                  <Stack direction={"row"} spacing={2}>
                    <Button variant="outlined">Allinea Agenda GP</Button>
                    <Button variant="containedCustom" onClick={onSubmit}>
                      Conferma
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </>
          )}

          {(type === "nonDisponibile" ||
            type === "duplicaIndisponibilità" ||
            type === "modificaIndisponibilità") && (
            <Grid container spacing={2}>
              <Grid item xs={12} md={3}>
                <RHFDateTimePicker
                  dateOnly
                  name="medIntIndisponibilita.dataInizio"
                  control={formMethods.control}
                  rules={{ required: "Campo obbligatorio" }}
                  serialize="dayjs"
                  valueFormat="YYYY-MM-DD"
                  displayFormat="DD/MM/YYYY"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <RHFDateTimePicker
                  dateOnly
                  name="medIntIndisponibilita.dataFine"
                  control={formMethods.control}
                  rules={{ required: "Campo obbligatorio" }}
                  serialize="dayjs"
                  valueFormat="YYYY-MM-DD"
                  displayFormat="DD/MM/YYYY"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <RHFTimePicker
                  name="medIntIndisponibilita.oraInizio"
                  control={formMethods.control}
                  rules={{ required: "Campo obbligatorio" }}
                  fullWidth
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <RHFTimePicker
                  name="medIntIndisponibilita.oraFine"
                  control={formMethods.control}
                  rules={{ required: "Campo obbligatorio" }}
                  fullWidth
                  size="small"
                />
              </Grid>
              <Grid item xs={12}>
                <Controller
                  name="medIntIndisponibilita.note"
                  control={formMethods.control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      fullWidth
                      multiline
                      rows={6}
                      placeholder="Inserire Note..."
                      sx={{
                        backgroundColor: "#F1F1F1",
                        borderRadius: "4px",
                        "& .MuiOutlinedInput-root": { padding: "12px" },
                        "& textarea": { fontSize: "14px" },
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>
          )}

          {type !== "nuovaAgenda" && (
            <Box display="flex" justifyContent="space-between" mt={3}>
              <Button
                variant="outlinedError"
                onClick={() => {
                  if (copiaDaMedico_Medico) {
                    formMethods.reset();
                    setCodiceMedico(null);
                    setPrestazioniFromMedico(null);
                  }
                  if (inserimentoMultiplo_Specialita) {
                    formMethods.reset();
                  }
                  onClose();
                }}
              >
                Uscita
              </Button>
              <Button
                variant="contained"
                onClick={onSubmit}
                disabled={
                  type === "copiaDaMedico" ? selectedRows.length < 1 : false
                }
              >
                Conferma
              </Button>
            </Box>
          )}
        </Box>
      </Modal>
    </>
  );
};

export default MedintModal;
